import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { useInitialFetch } from 'core/context/initialFetchContext';
import { bannerSliderSettings } from 'core/config/slides';
import { Link } from 'react-router-dom';
const img_api = process.env.REACT_APP_IMG_API;

const BannerV3 = () => {
    const { homeBanners: bannerData, loading, error } = useInitialFetch();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (error) return <div>Error loading banners</div>;

    const sortedBannerData = bannerData?.sort((a, b) => a.order - b.order);

    const renderBanner = (banner, index) => {
        const imageUrl = isMobile && banner.backgroundImageMobile 
            ? img_api + banner.backgroundImageMobile 
            : img_api + banner.backgroundImage;

        const isExternalLink = banner.link.startsWith('http');

        return (
            <div key={index}>
                {isExternalLink ? (
                    <a href={banner.link} target="_blank" rel="noopener noreferrer">
                        <div className="ltn__slide-item-inner ltn__slide-item-custom position-relative">
                            <img src={imageUrl} alt={`Banner ${index}`} className="img-fluid" />
                        </div>
                    </a>
                ) : (
                    <Link to={banner.link}>
                        <div className="ltn__slide-item-inner ltn__slide-item-custom position-relative">
                            <img src={imageUrl} alt={`Banner ${index}`} className="img-fluid" />
                        </div>
                    </Link>
                )}
            </div>
        );
    };

    return (
        <div className={`ltn__slider-area ltn__slider-3 position-relative  ${loading ? 'slide-loading bg-gray' : ''}`}>
            {sortedBannerData?.length > 1 ? (
                <Slider {...bannerSliderSettings}>
                    {sortedBannerData?.map((banner, index) => renderBanner(banner, index))}
                </Slider>
            ) : (
                sortedBannerData?.map((banner, index) => renderBanner(banner, index))
            )}
        </div>
    );
};

export default BannerV3;